var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRichText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 32,
    rx: 4,
    fill: "#C6FB55"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_612_9290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.25 7.75H11.75C11.3522 7.75 10.9706 7.90804 10.6893 8.18934C10.408 8.47064 10.25 8.85218 10.25 9.25V22.75C10.25 23.1478 10.408 23.5294 10.6893 23.8107C10.9706 24.092 11.3522 24.25 11.75 24.25H28.25C28.6478 24.25 29.0294 24.092 29.3107 23.8107C29.592 23.5294 29.75 23.1478 29.75 22.75V9.25C29.75 8.85218 29.592 8.47064 29.3107 8.18934C29.0294 7.90804 28.6478 7.75 28.25 7.75ZM24.875 19.75H15.125C14.9261 19.75 14.7353 19.671 14.5947 19.5303C14.454 19.3897 14.375 19.1989 14.375 19C14.375 18.8011 14.454 18.6103 14.5947 18.4697C14.7353 18.329 14.9261 18.25 15.125 18.25H24.875C25.0739 18.25 25.2647 18.329 25.4053 18.4697C25.546 18.6103 25.625 18.8011 25.625 19C25.625 19.1989 25.546 19.3897 25.4053 19.5303C25.2647 19.671 25.0739 19.75 24.875 19.75ZM24.875 16.75H15.125C14.9261 16.75 14.7353 16.671 14.5947 16.5303C14.454 16.3897 14.375 16.1989 14.375 16C14.375 15.8011 14.454 15.6103 14.5947 15.4697C14.7353 15.329 14.9261 15.25 15.125 15.25H24.875C25.0739 15.25 25.2647 15.329 25.4053 15.4697C25.546 15.6103 25.625 15.8011 25.625 16C25.625 16.1989 25.546 16.3897 25.4053 16.5303C25.2647 16.671 25.0739 16.75 24.875 16.75ZM24.875 13.75H15.125C14.9261 13.75 14.7353 13.671 14.5947 13.5303C14.454 13.3897 14.375 13.1989 14.375 13C14.375 12.8011 14.454 12.6103 14.5947 12.4697C14.7353 12.329 14.9261 12.25 15.125 12.25H24.875C25.0739 12.25 25.2647 12.329 25.4053 12.4697C25.546 12.6103 25.625 12.8011 25.625 13C25.625 13.1989 25.546 13.3897 25.4053 13.5303C25.2647 13.671 25.0739 13.75 24.875 13.75Z",
    fill: "#141046"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_612_9290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRichText);
export default __webpack_public_path__ + "static/media/rich-text.69d3d0cc392b4a4eef2b09bb48986e42.svg";
export { ForwardRef as ReactComponent };